import { useEffect, useRef, useState } from "react";
import ApiService from "../../api/ApiServices";
import moment from "moment";
import LoadImage from '../../assets/loader.gif';
import { useNavigate } from "react-router-dom";
import { AppPaths } from "../../utils/AppPaths";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { setPointData } from "../../redux/rootSlice";
import GoalBanner from "./GoalBanner";
import React from 'react';
import SecondaryButtonSmall from "../SecondaryButtonSmall";
import LeaderboardModal from "../../components/dashboard/LeaderboardModal";
import AlertModal from "../AlertModal";

const MyJourney = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [journeyDetails, setJourneyDetails] = useState<any>(null);
  const [load, setLoad] = useState<boolean>(false);
  const [loadMore, setLoadMore] = useState<boolean>(false);
  const [headerStats, setHeaderStats] = useState({ home: 0, stars: 0, fire: 0 });
  const [leaderboardModalOpen, setLeaderboardModalOpen] = useState(false);
  const [leaderboardLoading, setLeaderboardLoading] = useState(false);
  const [leaderboardData, setLeaderboardData] = useState<any>(null);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const leaderboardAutoOpenedRef = useRef(false);
  const [pagination, setPagination] = useState<any>({
    totalItems: 0,
    totalPages: 1,
    currentPage: 1,
    limit: 10,
  });
  const [currentPage, setCurrentPage] = useState<number>(1);

  const openAlert = (message: string) => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const getJourneyData = async (pageNumber: number = 1, isLoadMore: boolean = false) => {
    if (isLoadMore) {
      setLoadMore(true);
    } else {
      setLoad(true);
    }

    const response = await ApiService.getMyJourney(pageNumber, 10);
    const responseData = response?.data || {};

    setJourneyDetails((prev: any) => {
      if (pageNumber === 1 || !prev) {
        return responseData;
      }

      return {
        ...prev,
        ...responseData,
        challenges: [...(prev?.challenges || []), ...(responseData?.challenges || [])],
      };
    });

    const paginationData = response?.pagination || responseData?.pagination || {
      totalItems: 0,
      totalPages: 1,
      currentPage: pageNumber,
      limit: 10,
    };

    setPagination(paginationData);
    setCurrentPage(pageNumber);

    if (pageNumber === 1) {
      const pointsResponse = await ApiService.getPoints();

      const pointsData = pointsResponse?.data || {};
      setHeaderStats({
        home: Number(pointsData?.totalHousePoints) || 0,
        stars: Number(pointsData?.availablePoints) || 0,
        fire: Number(pointsData?.totalStreakPoints) || 0,
      });
    }

    if (isLoadMore) {
      setLoadMore(false);
    } else {
      setLoad(false);
    }
  }
  const pointsDetails = useAppSelector<any>(state => state.root.pointData);
  useEffect(() => {
    setJourneyDetails(null);
    setPagination({
      totalItems: 0,
      totalPages: 1,
      currentPage: 1,
      limit: 10,
    });
    setCurrentPage(1);
    getJourneyData(1);
  }, [])

  const onLoadMore = () => {
    if (loadMore || currentPage >= (pagination?.totalPages || 1)) {
      return;
    }

    getJourneyData(currentPage + 1, true);
  }

  const handleChallenge = (type: string, id: string) => {
    if (type === 'text') {
      navigate(`${AppPaths.DANCE_CHALLENGE}?id=${id}`)
    } else if (type === 'image' || type === 'video') {
      navigate(`${AppPaths.HALLOWEEN_CHALLENGE}?id=${id}&type=${type}`)
    } else {
      navigate(`${AppPaths.FALLFUN_QUIZ_CHALLENGE}?id=${id}`)
    }
  }
  const getProfileData = async () => {
    setLoad(true);
    const response = await ApiService.getProfile();
    dispatch(setPointData({ challengePoints: response?.data?.challengePoints, checkInPoints: response?.data?.checkInPoints}))
    setLoad(false)
  }

  const isWithinPostEndDateWindow = (endDateValue?: string) => {
    if (!endDateValue) return false;

    const endDateMoment = moment(endDateValue).startOf("day");
    if (!endDateMoment.isValid()) return false;

    const startWindow = endDateMoment.clone().add(1, "day");
    const endWindow = endDateMoment.clone().add(7, "day").endOf("day");
    const now = moment();

    return now.isBetween(startWindow, endWindow, undefined, "[]");
  };

  const openLeaderboardModal = async (options?: { auto?: boolean }) => {
    const isAutoOpen = Boolean(options?.auto);
    if (!isAutoOpen) {
      setLeaderboardModalOpen(true);
    }

    setLeaderboardLoading(true);

    try {
      const response = await ApiService.getLeaderboard();
      if (response?.status) {
        const firstLeaderboard = Array.isArray(response?.data)
          ? response.data[0] || null
          : null;
        setLeaderboardData(firstLeaderboard);

        if (isAutoOpen) {
          const competition = firstLeaderboard?.competition || {};
          const endDateValue = competition?.endDate || competition?.end_date;
          if (isWithinPostEndDateWindow(endDateValue)) {
            setLeaderboardModalOpen(true);
          }
        }
      } else {
        setLeaderboardData(null);
      }
    } catch (error) {
      setLeaderboardData(null);
      openAlert("Failed to load leaderboard");
    } finally {
      setLeaderboardLoading(false);
    }
  };

  useEffect(() => {
    if (leaderboardAutoOpenedRef.current) return;
    leaderboardAutoOpenedRef.current = true;
    openLeaderboardModal({ auto: true });
  }, []);

  useEffect(() => {
    if (pointsDetails === null) {
      getProfileData()
    }
  }, [])
  const renderTopGradient = () => (
    <svg
      // width="375"
      // height="123"
      viewBox="0 0 365 143"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position: "absolute",
        top: -32,
        zIndex: -10,
      }}
    >
      <path
        d="M-66 43L44.741 18.2962C142.95 -3.6119 244.864 -2.80936 342.716 20.6427L436 43"
        stroke="url(#paint0_linear_1102_5554)"
        stroke-width="133"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1102_5554"
          x1="16"
          y1="43"
          x2="363"
          y2="43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF9EEB" />
          <stop offset="0.145833" stop-color="#FF9728" stop-opacity="0.74" />
          <stop offset="0.302083" stop-color="#FFD203" stop-opacity="0.61" />
          <stop offset="0.510417" stop-color="#F1F232" stop-opacity="0.48" />
          <stop offset="0.65625" stop-color="#06AE56" stop-opacity="0.67" />
          <stop offset="0.859375" stop-color="#22A094" stop-opacity="0.77" />
          <stop offset="0.994236" stop-color="#91A8EC" />
        </linearGradient>
      </defs>
    </svg>
  );
  const renderHeaderImages = () => {
    return (
      <div className="flex z-10 mb-4 pt-1">
        <div className="flex flex-row flex-1 pl-5 items-center">
          <img
            src={journeyDetails?.house?.image  || require("../../assets/placeholder_gem.png")}
            alt=""
            className="header-jem"
          />
          <div className="inter-text-16-extrabold px-3">{pointsDetails?.challengePoints}&nbsp;pts</div>
        </div>
        <img
          src={require("../../assets/u4uOnb.png")}
          alt=""
          className="header-u4u "
        />
        <div className="flex flex-row flex-1 justify-end pr-5 items-center">
          <img
            src={require("../../assets/header_star.png")}
            alt=""
            className="header-star mr-3 "
          />
          <div className="inter-text-16-extrabold">{pointsDetails?.checkInPoints}&nbsp;pts</div>
        </div>
      </div>
    );
  };

  const Header = ({ name = "User", stats = { home: 0, stars: 0, fire: 0 } }) => {
  return (
    <div className="container">
      <header className="header-banner">
        <svg width="0" height="0">
          <defs>
            <clipPath id="concaveCurve" clipPathUnits="objectBoundingBox">
              {/* This path draws a box and then arcs INWARD at the bottom */}
              {/* <path d="M0,0 H1 V0.8 Q0.5,0.6 0,0.8 Z" /> */}
              <path d="M0,0 H1 V1 Q0.5,0.2 0,1 Z" />
              {/* <path d="M0,0 H1 V1 C0.75,0.2 0.25,0.2 0,1 Z" /> */}
            </clipPath>
          </defs>
        </svg>

        <div className="grid w-full grid-cols-2 items-start">
          <div className="logo justify-self-start">
            <img src={require("../../assets/u4u_logo.png")} alt="U4u Logo" className="header-u4u" />
          </div>

          <div className="stats-container justify-self-end">
            <div className="stat-bubble cursor-pointer" onClick={() => {
                openLeaderboardModal();
              }}>
              <span><img src={require("../../assets/house.png")} alt="" className="w-4 h-4" /></span> {stats.home}
            </div>
            <div className="stat-bubble cursor-pointer" onClick={() => {
              navigate(AppPaths.PRIZES);
            }}>
              <span><img src={require("../../assets/star.png")} alt="" className="w-5 h-5" /></span> {stats.stars}
            </div>
            <div className="stat-bubble cursor-pointer" onClick={() => {
              navigate(AppPaths.MOODRING);
            }}>
              <span><img src={require("../../assets/fire.png")} alt="" className="w-4 h-4" /></span> {stats.fire}
            </div>
          </div>
        </div>
      </header>

      {/* Text below the curve */}
      <div className="welcome-text my-juourney-text mb-5">{name}!</div>
    </div>
  );
};

  const getColor = (value: string) => {
    if (value === 'Culture') {
      return '#FBBA65B2';
    } else if (value === 'self' || value === 'Self') {
      return '#FB6ADD4D'
    } else if (value === 'Environment') {
      return '#27E2944D'
    } else {
      return '#4BBAFF4D';
    }
  }

  const renderSvg = () => {
    return (
      <div className="flex flex-col items-center relative">
        <div className="circle-icon absolute z-10 py-4 px-5 flex">
          <img
            alt=""
            className="h-8 w-7"
            src={require("../../assets/U-logo.png")}
          />
        </div>
        <div className="relative flex flex-row -right-1">
          <div className="relative">
            <div className="inter-32-bold absolute right-8 top-11 font-white">
              {journeyDetails?.pillers[0]?.points}
            </div>
            <div className="inter-13-bold absolute right-8 bottom-6 font-white">
              {journeyDetails?.pillers[0]?.piller}
            </div>

            <svg
              width="130"
              height="130"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            // className="mr-1 mb-1"
            >
              <path
                d="M6.18056 94.5C2.76714 94.5 -0.0210419 91.7299 0.202042 88.3238C0.87645 78.0269 3.23386 67.8956 7.19339 58.3364C11.9425 46.8711 18.9033 36.4535 27.6784 27.6784C36.4536 18.9033 46.8712 11.9425 58.3364 7.19338C67.8956 3.23386 78.0269 0.876449 88.3238 0.20204C91.7299 -0.0210491 94.5 2.76713 94.5 6.18056L94.5 88.3194C94.5 91.7329 91.7329 94.5 88.3194 94.5H6.18056Z"
                fill="#FF9728"
              />
            </svg>
          </div>

          <div className="relative">
            <div className="inter-32-bold absolute left-8 top-11 font-white">
              {journeyDetails?.pillers[2]?.points}
            </div>
            <div className="inter-13-bold absolute right-8 bottom-6 font-white">
              {journeyDetails?.pillers[2]?.piller}
            </div>
            <svg
              width="130"
              height="130"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M87.8194 94.5C91.2329 94.5 94.0209 91.7299 93.799 88.3237C93.1282 78.0268 90.7832 67.8955 86.8447 58.3364C82.1207 46.8711 75.1967 36.4535 66.468 27.6784C57.7393 18.9033 47.3768 11.9425 35.9722 7.19338C26.4738 3.23806 16.4073 0.881451 6.17614 0.204191C2.77016 -0.0212689 -7.62939e-06 2.76713 -7.62939e-06 6.18056L0 88.3194C0 91.7329 2.76713 94.5 6.18056 94.5H87.8194Z"
                fill="#629EF8"
              />
            </svg>
          </div>
        </div>
        <div className="relative flex flex-row -right-1">
          <div className="relative">
            <div className="inter-13-bold absolute right-10 top-4 font-white">
              {journeyDetails?.pillers[3]?.piller}
            </div>
            <div className="inter-32-bold absolute right-10 top-8 font-white">
              {journeyDetails?.pillers[3]?.points}
            </div>
            <svg
              width="130"
              height="130"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            // className="mr-1"
            >
              <path
                d="M6.18056 0C2.76714 0 -0.0212708 2.77017 0.204193 6.17615C0.881454 16.4073 3.23805 26.4738 7.19339 35.9722C11.9425 47.3769 18.9033 57.7393 27.6784 66.468C36.4536 75.1967 46.8712 82.1207 58.3364 86.8447C67.8955 90.7832 78.0269 93.1282 88.3237 93.799C91.7299 94.0209 94.5 91.2329 94.5 87.8194L94.5 6.18056C94.5 2.76713 91.7329 0 88.3194 0H6.18056Z"
                fill="#CF91EC"
              />
            </svg>
          </div>

          <div className="relative">
            <div className="inter-13-bold absolute right-5 top-4 font-white">
              {journeyDetails?.pillers[1]?.piller}
            </div>
            <div className="inter-32-bold absolute left-8 top-8 font-white">
              {journeyDetails?.pillers[1]?.points}
            </div>
            <svg
              width="130"
              height="130"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M87.8194 0C91.2329 0 94.0212 2.77014 93.7969 6.17619C93.1232 16.4074 90.7791 26.4738 86.8447 35.9722C82.1207 47.3769 75.1967 57.7393 66.468 66.468C57.7393 75.1967 47.3768 82.1207 35.9722 86.8447C26.4738 90.7791 16.4074 93.1232 6.17619 93.7969C2.77014 94.0212 -7.62939e-06 91.2329 -7.62939e-06 87.8194L0 6.18056C0 2.76713 2.76713 0 6.18056 0H87.8194Z"
                fill="#4DE19A"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  };

const JourneyPillarsWheel = ({ journeyDetails }: { journeyDetails: any }) => {
  const pillars = journeyDetails?.pillers || [];

  const findPillar = (keywords: string[], fallbackIndex: number) => {
    const match = pillars.find((pillar: any) => {
      const name = String(pillar?.piller || "").toLowerCase();
      return keywords.some((keyword) => name.includes(keyword));
    });
    return match || pillars[fallbackIndex] || { piller: "", points: 0 };
  };

  const sections = [
    { 
      id: 'strong', 
      label: "Strong Self", 
      pos: "top-0 left-0", 
      pointsPos: "top-12 right-9",
      pathD: "M 15,115 A 108,108 0 0,1 115,15", 
      startOffset: "18%", // Pushed right slightly to make room for icon
      iconStyle: { top: '110px', left: '6px' } 
    },
    { 
      id: 'connection', 
      label: "Connection", 
      pos: "top-0 right-0", 
      pointsPos: "top-12 left-9",
      pathD: "M 15,15 A 108,108 0 0,1 115,115", 
      startOffset: "18%",
      iconStyle: { top: '110px', right: '6px'} 
    },
    { 
      id: 'culture', 
      label: "Culture", 
      pos: "bottom-0 left-0", 
      pointsPos: "bottom-12 right-9",
      pathD: "M 115,115 A 108,108 0 0,1 15,15", 
      startOffset: "18%",
      iconStyle: { bottom: '110px', left: '6px' } 
    },
    { 
      id: 'environment', 
      label: "Environment", 
      pos: "bottom-0 right-0", 
      pointsPos: "bottom-12 left-9",
      pathD: "M 115,15 A 108,108 0 0,1 15,115", 
      startOffset: "18%",
      iconStyle: { bottom: '110px', right: '6px' } 
    },
  ];

  return (
    <div className="flex flex-col items-center mt-5 mb-3">
      <div className="relative w-[276px] h-[276px]">
        {sections.map((sec) => (
          <div key={sec.id} className={`absolute w-[134px] h-[134px] ${sec.pos}`}>
            
            {/* 1. Lighter Color Layer */}
            <img src={require(`../../assets/ic_${sec.id}Inner.png`)} alt="" className="absolute inset-0 w-full h-full object-contain" />
            
            {/* 2. Darker Border Layer */}
            <img src={require(`../../assets/ic_${sec.id}Outer.png`)} alt="" className="absolute inset-0 w-full h-full object-contain z-10" />
            
            {/* 3. The White Icon (Small icon next to label) */}
            <img 
              src={require(`../../assets/ic_${sec.id}Icon.png`)} // Ensure you have ic_strongIcon.png etc.
              alt="" 
              className="absolute w-[18px] h-[18px] z-20 object-contain"
              style={sec.iconStyle}
            />

            {/* 4. SVG Curved Label */}
            <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none overflow-visible" viewBox="0 0 134 134">
              <defs><path id={`path-${sec.id}`} d={sec.pathD} fill="none" /></defs>
              <text className="fill-white font-bold text-[18px] tracking-wider">
                <textPath xlinkHref={`#path-${sec.id}`} startOffset={sec.startOffset} textAnchor="start" dominantBaseline="central">
                  {sec.label}
                </textPath>
              </text>
            </svg>

            {/* 5. Points */}
            <div className={`absolute z-20 text-white inter-32-semibold ${sec.pointsPos}`}>
              {findPillar([sec.id === 'strong' ? 'self' : sec.id], 0)?.points ?? 0}
            </div>
          </div>
        ))}

        {/* Center Logo */}
        <div className="absolute inset-0 m-auto z-30 w-[72px] h-[72px] bg-[#F5F5F5] rounded-full flex items-center justify-center shadow-md">
          <img src={require("../../assets/U-logo.png")} alt="U" className="h-9 w-8" />
        </div>
      </div>
    </div>
  );
};



  return (
    <>
      {load ? <div className="flex justify-center items-center h-screen mb-5">
        <img width="100px" className="center" src={LoadImage} alt="loader" />
      </div> : <div className="flex flex-col relative pb-20">
        <LeaderboardModal
              visible={leaderboardModalOpen}
              loading={leaderboardLoading}
              data={leaderboardData}
              onClose={() => setLeaderboardModalOpen(false)}
            />
        {/* {renderTopGradient()}
        {renderHeaderImages()} */}
        <Header name='My Journey' stats={headerStats} />
          <GoalBanner />
        {/* <div className="inter-20-bold text-center">My Journey</div> */}
        {/* {renderSvg()} */}
        <JourneyPillarsWheel journeyDetails={journeyDetails} />
        <div className="flex justify-center px-3 mt-2 mb-2">
           <SecondaryButtonSmall
            text={"My Point History"}
            onClick={() => {
              navigate(AppPaths.MY_POINT_HISTORY);
            }}
            containerStyles="my-history-btn cursor-pointer"
            textStyle="secondary-btn-text my-history-btn-text"
          />
        </div>
        <div className="flex flex-row px-3">
          <div className="inter-12-bold flex flex-1">Challenges</div>
          <div className="inter-12-bold flex">Points Earned</div>
        </div>

        <div className="">
          {journeyDetails?.challenges?.map((item: any, index: any) => {
            return (<div key={item?._id || `${item?.challengeId?._id}-${index}`} className="my-journey-card mx-3 flex flex-row items-center px-3 py-1 mt-2" style={{ backgroundColor: `${getColor(item?.pillar)}`, borderColor: `${getColor(item?.pillar)}`, borderWidth: '2px', borderStyle: 'solid' }}>
              <div className="flex flex-1 flex-col text-left">
                <div className="inter-text-14 text-left cursor-pointer" onClick={() => handleChallenge(item?.challengeId?.type, item?.challengeId?._id)}>
                  {item?.title}
                </div>
                <div className="inter-regular-12">{moment(item?.createdAt).format('MMMM DD, YYYY')}</div>
              </div>
              <div className="flex justify-end text-right">
                {/* <div className="flex flex-1 items-center justify-center inter-text-14-semibold">
                  {item?.availablePoints}
                </div> */}
                <div className="inter-text-14-semibold whitespace-nowrap">
                  {item?.urPoints || '-'} / {item?.availablePoints}
                </div>
              </div>
            </div>)
          })}
        </div>
        {currentPage < (pagination?.totalPages || 1) && (
          <div className="flex justify-center mt-4">
            <div
              onClick={onLoadMore}
              className="btn-onb4-text underline underline-offset-4 cursor-pointer"
            >
              {loadMore ? "Loading..." : "Load More"}
            </div>
          </div>
        )}
      </div>}
      <AlertModal
        visible={showAlert}
        title="Oops!"
        message={alertMessage}
        onConfirm={() => setShowAlert(false)}
      />
    </>
  );
};

export default MyJourney;
